import { gql } from '@apollo/client';

export const USER_SETTINGS_FRAGMENT = gql`
  fragment UserSettings on User {
    settings {
      activeCompanyId
      activeAssessmentId
      activeAgeGroupIds
    }
  }
`;

export const UPDATE_USER_SETTINGS = gql`
  mutation UpdateUserSettings($_id: ID!, $settings: UserSettingsInput!) {
    updateUserSettings(_id: $_id, settings: $settings) {
      _id
      ...UserSettings
    }
  }

  ${USER_SETTINGS_FRAGMENT}
`;

export const GET_CURR_USER = gql`
  query getCurrUser {
    loggedInUser {
      _id
      name
      email
      isAdmin
      settings {
        activeCompanyId
        activeAssessmentId
        activeAgeGroupIds
      }
    }
  }
`;

// Kept out of GET_CURR_USER so an older server, or a persisted cache without the field,
// only disables the idle sign-out instead of failing the current-user query.
export const GET_IDLE_SIGN_OUT_MINUTES = gql`
  query GetIdleSignOutMinutes {
    loggedInUser {
      _id
      idleSignOutMinutes
    }
  }
`;

export const APPLY_SELECTION_TARGET = gql`
  mutation ApplySelectionTarget($target: SelectionTargetInput!) {
    applySelectionTarget(target: $target) {
      granted
      reason
      skippedIdCount
      user {
        _id
        ...UserSettings
      }
    }
  }

  ${USER_SETTINGS_FRAGMENT}
`;

export const RESET_PASSWORD = gql`
  mutation SetPassword($password: String!) {
    resetPassword(password: $password) {
      success
    }
  }
`;

export const VERIFY_USER = gql`
  mutation VerifyUser($verificationCode: ID!) {
    verifyUser(verificationCode: $verificationCode) {
      token
    }
  }
`;

export const REQUEST_PASSWORD_RESET = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordResetLink(email: $email) {
      success
    }
  }
`;

export const RESET_PASSWORD_WITH_TOKEN = gql`
  mutation ResetPasswordWithToken($token: String!, $password: String!) {
    resetPasswordWithToken(token: $token, password: $password) {
      success
    }
  }
`;
